import { LAST_STAND_MIX, lastStandCutoff } from "./mixPolicy";
import { LIMITER } from "./audioCues";

/** The nodes every sound goes through: effects and music buses → master → limiter → speakers (audio.ts GameAudio). */
export interface AudioGraph {
  readonly master: GainNode;
  readonly sfxGain: GainNode;
  readonly musicGain: GainNode;
  /** The music bus's last-stand low-pass and level (musicGain → filter → gain → master). */
  readonly standFilter: BiquadFilterNode;
  readonly standGain: GainNode;
}

/** The levels a new graph starts at, so a context built again mid-game sounds as the old one did. */
export interface GraphLevels { readonly master: number; readonly sfx: number; readonly music: number; readonly stand: number | null }

export function buildGraph(ctx: AudioContext, levels: GraphLevels): AudioGraph {
  const limiter = ctx.createDynamicsCompressor();
  limiter.threshold.value = LIMITER.thresholdDb; limiter.knee.value = LIMITER.kneeDb; limiter.ratio.value = LIMITER.ratio;
  limiter.attack.value = LIMITER.attackS; limiter.release.value = LIMITER.releaseS;
  limiter.connect(ctx.destination);
  const master = ctx.createGain();
  master.gain.value = levels.master;
  master.connect(limiter);
  const sfxGain = ctx.createGain();
  sfxGain.gain.value = levels.sfx;
  sfxGain.connect(master);
  const musicGain = ctx.createGain();
  musicGain.gain.value = levels.music;
  const standFilter = ctx.createBiquadFilter();
  standFilter.type = "lowpass";
  standFilter.frequency.value = lastStandCutoff(levels.stand);
  const standGain = ctx.createGain();
  standGain.gain.value = levels.stand === null ? 1 : LAST_STAND_MIX.DuckLevel;
  musicGain.connect(standFilter).connect(standGain).connect(master);
  return { master, sfxGain, musicGain, standFilter, standGain };
}
